import { render, staticRenderFns } from "./BookAllSender.vue?vue&type=template&id=4379aad0"
import script from "./BookAllSender.vue?vue&type=script&lang=js"
export * from "./BookAllSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports